'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');



const AnimationDurationMs=380;let

ToggleSidebarButtonDirective=class ToggleSidebarButtonDirective extends BaseControllerBackedDirective{
get textBindings(){
return['collapsedClass','selector'];
}

get template(){
return'<div ng-click="controller.toggleSidebarVisibility()" class="toggle-groups-sidebar-button" ng-class="{collapsed: controller.isCollapsed}"></div>';
}

get controller(){
return ToggleSidebarButtonDirectiveController;
}};let


ToggleSidebarButtonDirectiveController=class ToggleSidebarButtonDirectiveController{
static get $inject(){
return['displaySettingsService','elementService','$rootScope','$timeout'];
}

constructor(displaySettingsService,elementService,$rootScope,$timeout){
this._displaySettingsService=displaySettingsService;
this._elementService=elementService;
this._$rootScope=$rootScope;
this._$timeout=$timeout;

this._updateSidebarVisibility(!1);
}

toggleSidebarVisibility(){
this._displaySettingsService.toggleSidebarVisibility();

this._updateSidebarVisibility();
}

_updateSidebarVisibility(broadcastResize=!0){
if(!this._displaySettingsService.isLoaded){
return;
}

if(this._displaySettingsService.stickySettings.get('groupsSidebarVisible')){
this._elementService.removeClass(this.selector,this.collapsedClass);
this.isCollapsed=!1;
}else{
this._elementService.addClass(this.selector,this.collapsedClass);
this.isCollapsed=!0;
}

if(!broadcastResize){
return;
}

this._$timeout(()=>this._$rootScope.$broadcast('resize::resize'),AnimationDurationMs);
}};


module.exports=ToggleSidebarButtonDirective;
//# sourceMappingURL=toggleSidebarButtonDirective.js.map
